import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ShippingMethod } from '../../../page-builder/interface/checkoutInterface';
import { CheckoutDataPayload } from '../../../page-builder/interface/apiServiceInterface';

export interface CheckoutState {
  isApiLoading: boolean;
  availableShippingMethods: ShippingMethod[];
  selectedShippingMethod: ShippingMethod | null;
  isDeclinePopup: boolean;
  declineReasonCode: string;
  checkoutOrderID: string;
  purchaseToken: string;
  hasSubscription: boolean;
  hasUnsavedChanges: boolean;
  nextpageConfig: {
    id: number | string;
    pageType: string;
    pageVisiblity: string;
  };
  pageId: string | null;
  isVGSFormError: boolean;
  isSetShippingApiLoading: number;
  currentPageFunnelId: string;
}

const initialState: CheckoutState = {
  isApiLoading: false,
  availableShippingMethods: [],
  selectedShippingMethod: null,
  isDeclinePopup: false,
  declineReasonCode: '',
  checkoutOrderID: '',
  purchaseToken: '',
  hasSubscription: false,
  hasUnsavedChanges: false,
  nextpageConfig: {
    id: '',
    pageType: '',
    pageVisiblity: '',
  },
  isVGSFormError: false,
  isSetShippingApiLoading: 0,
  currentPageFunnelId: '',
  pageId: null,
};

export const checkoutSlice = createSlice({
  name: 'checkout',
  initialState,
  reducers: {
    setAvailableShippingMethods(
      state,
      action: PayloadAction<ShippingMethod[]>,
    ) {
      state.availableShippingMethods = action.payload;
    },
    setApiLoading(state, action: PayloadAction<boolean>) {
      state.isApiLoading = action.payload;
    },
    setSelectedShippingMethod(
      state,
      action: PayloadAction<ShippingMethod | null>,
    ) {
      state.selectedShippingMethod = action.payload;
    },
    setIsDeclinePopup(state, action: PayloadAction<boolean>) {
      state.isDeclinePopup = action.payload;
    },
    setDeclineReasonCode(state, action: PayloadAction<string>) {
      state.declineReasonCode = action.payload;
    },
    setCheckoutOrderID(state, action: PayloadAction<string>) {
      state.checkoutOrderID = action.payload;
    },
    setPurchaseToken(state, action: PayloadAction<string>) {
      state.purchaseToken = action.payload;
    },
    setHasSubscription(state, action: PayloadAction<CheckoutDataPayload>) {
      state.hasSubscription = action.payload.Cart.HasSubscription;
    },
    setHasUnsavedChanges(state, action: PayloadAction<boolean>) {
      state.hasUnsavedChanges = action.payload;
    },
    setNextPageConfig(
      state,
      action: PayloadAction<{
        id: number | string;
        pageType: string;
        pageVisiblity: string;
      }>,
    ) {
      state.nextpageConfig = action.payload;
    },
    setIsVGSFormError(state, action: PayloadAction<boolean>) {
      state.isVGSFormError = action.payload;
    },
    setCurrentPageFunnelId(state, action: PayloadAction<string>) {
      state.currentPageFunnelId = action.payload;
    },
    setIsSetShippingApiLoading(state, action) {
      state.isSetShippingApiLoading = action.payload;
    },
    setPageId(state, action: PayloadAction<string | null>) {
      state.pageId = action.payload;
    },
  },
});

export const {
  setApiLoading,
  setSelectedShippingMethod,
  setIsDeclinePopup,
  setDeclineReasonCode,
  setCheckoutOrderID,
  setPurchaseToken,
  setHasSubscription,
  setAvailableShippingMethods,
  setHasUnsavedChanges,
  setNextPageConfig,
  setIsVGSFormError,
  setCurrentPageFunnelId,
  setIsSetShippingApiLoading,
  setPageId,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
